import { GxIcon } from "./icon.js"



export class GxIconMagnifier extends GxIcon {

  constructor() {
    super()
    const temp = document.createElement("template")
    temp.innerHTML = `
<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
  <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
  <g id="SVGRepo_iconCarrier"> 
    <path d="M18.5 18.5L22 22" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path>
    <path d="M6.75 3.27093C8.14732 2.46262 9.76964 2 11.5 2C16.7467 2 21 6.25329 21 11.5C21 16.7467 16.7467 21 11.5 21C6.25329 21 2 16.7467 2 11.5C2 9.76964 2.46262 8.14732 3.27093 6.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path> 
  </g>
</svg>
`
    super.addHTML(temp)
  }
}


if (!window.customElements.get("gx-icon-magnifier")) window.customElements.define("gx-icon-magnifier", GxIconMagnifier)
